/** @internal */
export function getRandomString(len = 32): string {
    let chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'

    let randString = ''
    for (let i = 0; i < len; i++) {
        randString += chars[Math.floor(Math.random() * chars.length)]
    }

    if (/undefined/i.test(randString)) {
        if ('crypto' in self && 'getRandomValues' in crypto && 'Uint32Array' in self) {
            randString = crypto.getRandomValues(new Uint32Array(4)).join('')
        }
    }

    if (/undefined/i.test(randString)) {
        randString = 'INVALID_RANDOM_STRING'
    }

    return randString
}

/** @internal */
export function getRandomWithinRange(max: number, min: number, inclusive: boolean = false): number {
    return Math.floor(Math.random() * (max - min + (inclusive ? 1 : 0)) + min)
}
